import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Close from '../../../svg/Close'
import { ExclamationCircleIcon } from '@heroicons/react/outline'

const ErrorCard = ({ error, closeButton, closeSize }) => {
    const [isVisible, setIsVisible] = useState(closeButton)

    const handleClose = () => {
        setIsVisible(false)
    }

    return closeButton || error ? (
        <div className="absolute bottom-full right-0 md:w-96 w-full h-auto bg-white">
            <div className="w-full h-full gap-x-4.5 bg-errorBackground border-l-4 p-4 border-red flex items-top md:justify-center justify-start">
                <ExclamationCircleIcon className="text-red w-5 h-5" />
                <p className="w-4/5 text-textDarkerGray font-medium text-sm">
                    {error}
                </p>
                {isVisible && <Close size={closeSize} onClick={handleClose} />}
            </div>
        </div>
    ) : null
}

ErrorCard.propTypes = {
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    closeButton: PropTypes.bool,
    closeSize: PropTypes.number,
}

export default ErrorCard
